'use strict';

var React = require('react');

var SvgAddCodeMajor = function SvgAddCodeMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.03 7.28a.75.75 0 0 0-1.06-1.06l-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25a.75.75 0 0 0 1.06-1.06l-2.72-2.72 2.72-2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.97 13.78a.75.75 0 0 0 1.06 0l3.25-3.25a.75.75 0 0 0 0-1.06l-3.25-3.25a.75.75 0 1 0-1.06 1.06l2.72 2.72-2.72 2.72a.75.75 0 0 0 0 1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6.75a.75.75 0 0 1 .75.75v1.75h1.75a.75.75 0 0 1 0 1.5h-1.75v1.75a.75.75 0 0 1-1.5 0v-1.75h-1.75a.75.75 0 0 1 0-1.5h1.75v-1.75a.75.75 0 0 1 .75-.75Z"
  }));
};
SvgAddCodeMajor.displayName = "AddCodeMajor";

exports.SvgAddCodeMajor = SvgAddCodeMajor;
